import ReportDataList from './List';
import LinkDownloadPDF from './LinkDownloadPDF';

export default {
  list: ReportDataList,
};

export { LinkDownloadPDF };
